import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const urlInputViewer = {
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map